import { render, staticRenderFns } from "./TheVideoAdd.vue?vue&type=template&id=1bf5559c&scoped=true&"
import script from "./TheVideoAdd.vue?vue&type=script&lang=js&"
export * from "./TheVideoAdd.vue?vue&type=script&lang=js&"
import style0 from "./TheVideoAdd.vue?vue&type=style&index=0&id=1bf5559c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf5559c",
  null
  
)

export default component.exports